(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestie-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bestie-product]').forEach((section) => {
    const variant = section.querySelector('[data-bestie-variant]');
    const quantity = section.querySelector('[data-bestie-quantity]');
    const packProperty = section.querySelector('[data-bestie-pack-property]');
    const total = section.querySelector('[data-bestie-total]');
    const delivery = section.querySelector('[data-bestie-delivery]');
    const radios = section.querySelectorAll('input[name="bestie_pack"]');
    const oneDelivery = section.dataset.deliveryOne;
    const multiDelivery = section.dataset.deliveryMulti;

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        variant.value = radio.value;
        quantity.value = radio.dataset.orderQuantity;
        packProperty.value = radio.dataset.packName;
        total.textContent = radio.dataset.total;
        delivery.textContent = Number(radio.dataset.packQuantity) > 1 ? multiDelivery : oneDelivery;
      });
    });

    const mainImage = section.querySelector('.bestie__hero-image');
    section.querySelectorAll('[data-bestie-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        mainImage.srcset = thumb.dataset.srcset;
        mainImage.sizes = '(max-width: 820px) 100vw, 50vw';
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.dataset.alt;
        section.querySelectorAll('[data-bestie-thumb]').forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-selected');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["growth-start"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var link = event.target.closest('[data-growth-kit-link]');
  if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  var chooser = document.getElementById('growth-kits');
  if (!chooser) return;
  event.preventDefault();
  window.location.hash = 'growth-kits';
  var heading = document.getElementById(chooser.getAttribute('aria-labelledby'));
  if (heading) heading.focus({ preventScroll: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
  const quoteJobDetails = document.querySelector('#quote-job-details');
  if (quoteJobDetails && Array.from(quoteJobDetails.querySelectorAll('input, select')).some(field => field.value.trim())) quoteJobDetails.open = true;
  const quoteResponse = document.querySelector('#QuoteForm [data-quote-response]');
  const quoteParams = new URLSearchParams(window.location.search);
  const quoteReference = document.querySelector('#quote-reference');
  if (quoteReference && !quoteReference.value && window.crypto?.getRandomValues) {
    const bytes = window.crypto.getRandomValues(new Uint8Array(4));
    const suffix = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('').toUpperCase();
    quoteReference.value = 'OFS-' + new Date().toISOString().slice(0, 10).replaceAll('-', '') + '-' + suffix;
  }
  const quoteAttribution = document.querySelector('#quote-attribution');
  if (quoteAttribution) {
    quoteAttribution.value = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].map(key => {
      const value = (quoteParams.get(key) || '').replace(/[^a-zA-Z0-9 _.-]/g, '').slice(0, 100);
      return value ? key + '=' + value : '';
    }).filter(Boolean).join('; ');
  }
  const quoteSource = document.querySelector('#quote-source-product');
  const quoteProductParam = quoteParams.get('product') || '';
  const quoteProduct = /^[a-z0-9][a-z0-9-]{0,199}$/.test(quoteProductParam) ? quoteProductParam : '';
  const reference = document.querySelector('#quote-product-reference');
  const context = document.querySelector('#quote-product-context');
  // Restore only the nonpersonal link reference on a retry. Customer-entered fields stay untouched.
  if (quoteProduct && reference && context) {
    const title = (quoteParams.get('product_title') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 200);
    const root = (document.querySelector('[data-product-root]')?.dataset.productRoot || '/').replace(/\/$/, '');
    context.value = (title ? title + '\n' : '') + root + '/products/' + quoteProduct;
    const requestedQuantity = quoteParams.get('requested_quantity') || '';
    if (/^[1-9][0-9]{0,6}$/.test(requestedQuantity) && Number(requestedQuantity) <= 1000000 && context.dataset?.quantityLabel) {
      context.value += '\n' + context.dataset.quantityLabel.replace('__QUANTITY__', requestedQuantity);
    }
    reference.hidden = false;
    if (quoteSource) quoteSource.value = quoteProduct;
  }
  if (quoteResponse) {
    quoteResponse.focus({ preventScroll: true });
    quoteResponse.scrollIntoView({ block: 'start' });
  } else {
    const quoteItem = (quoteParams.get('item') || '').replace(/[^a-z0-9\s-]/gi, ' ').replace(/[-\s]+/g, ' ').trim().slice(0, 200);
    if (quoteSource) quoteSource.value = quoteProduct || (quoteItem ? 'enquiry: ' + quoteItem : '');
    // Collection links carry only optional job context, never personal details.
    // Product-specific enquiries take precedence; retries and saved fields are preserved.
    if (!quoteProduct && !quoteItem) {
      const range = quoteParams.get('range');
      const messages = document.querySelector('[data-hinged-message]')?.dataset;
      const ranges = new Map([
        ['hinged-joint', ['Hinged joint', messages?.hingedMessage]],
        ['fixed-knot', ['Fixed knot', messages?.fixedMessage]],
        ['pickets', ['', messages?.picketsMessage]]
      ]);
      if (ranges.has(range)) {
        const [mesh, message] = ranges.get(range);
        const lengthField = document.querySelector('#quote-length');
        const meshField = document.querySelector('#quote-mesh');
        const messageField = document.querySelector('#quote-message');
        const length = (quoteParams.get('length') || '').replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, 80);
        if (lengthField && !lengthField.value) lengthField.value = length;
        if (meshField && !meshField.value && mesh) meshField.value = mesh;
        if (messageField && !messageField.value && message) messageField.value = message;
      }
    }
    if (quoteItem) {
      if (quoteJobDetails) quoteJobDetails.open = true;
      const pk = document.querySelector('#quote-pickets');
      if (pk && !pk.value) pk.value = quoteItem;
      const msg = document.querySelector('#quote-message');
      const messageTemplate = document.querySelector('[data-enquiry-message]')?.dataset.enquiryMessage || '__ITEM__';
      if (msg && !msg.value) msg.value = messageTemplate.replace('__ITEM__', quoteItem);
      const anchor = document.getElementById('delivered-price');
      if (anchor) anchor.scrollIntoView({ block: 'start' });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spring-smash"] && !Shopify.designMode) return;
  try {
    
function initSmash(root){root.querySelectorAll('[data-smash]').forEach(section=>{if(section.dataset.ready)return;section.dataset.ready='true';const track=section.querySelector('.smash__products--carousel');if(track){section.querySelector('[data-smash-prev]')?.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));section.querySelector('[data-smash-next]')?.addEventListener('click',()=>track.scrollBy({left:track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));}})}initSmash(document);document.addEventListener('shopify:section:load',e=>initSmash(e.target));

  } catch(e) { console.error(e); }
})();
})();
